export default function Home() {
  return (
    <div 
      className="min-h-screen text-white font-body"
      style={{
        backgroundColor: '#0a0a0a',
        backgroundImage: 'url(/images/metal-bg.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
      }}
    >
      
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-tactical-black/90 backdrop-blur border-b border-tactical-border">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="/images/COUP_logo2.png" alt="CounterScript" className="h-8 w-auto" />
            <span className="font-headline text-xl tracking-wider text-white">COUNTERSCRIPT HQ</span>
          </a>
          <div className="flex items-center gap-8">
            <a href="/" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">HOME</a>
            <a href="/training" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">TRAINING</a>
            <a href="https://play.counterscripthq.com/data-hub" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">DATA HUB</a>
            <a href="/gear" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">GEAR</a>
            <a href="/contact" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">CONTACT</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="min-h-screen flex flex-col items-center justify-center text-center px-4 pt-20 relative"
        style={{
          backgroundImage: 'url(/images/hero-bg.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10">
          <h1 className="font-headline text-6xl md:text-8xl tracking-wider mb-4">
            COUNTERSCRIPT<span className="text-tactical-amber">HQ</span>
          </h1>
          <p className="font-headline text-xl md:text-2xl tracking-widest text-tactical-amber mb-6">
            — Training HQ for Resistance Literacy —
          </p>
          <p className="font-body text-lg text-gray-300 max-w-2xl mx-auto mb-10">
            Train your faction, sharpen your voice, and fight back against illiteracy.
          </p>
          <a 
            href="https://play.counterscripthq.com/data-hub"
            className="inline-block font-headline text-lg tracking-widest border-2 border-tactical-amber text-tactical-amber px-10 py-4 hover:bg-tactical-amber hover:text-black transition"
          >
            ENTER HQ
          </a>
        </div>
      </section>

      {/* Three Cards Section */}
      <section className="py-20 px-4 bg-tactical-black">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* The Academy Card */}
          <div className="border border-tactical-border bg-tactical-dark rounded overflow-hidden">
            <div className="p-6">
              <h3 className="font-headline text-2xl tracking-wider text-white mb-2">THE ACADEMY</h3>
              <p className="font-body text-gray-400 mb-4">Training. Foundations. Drills.</p>
            </div>
            <div className="h-48 overflow-hidden">
              <img 
                src="/images/academy-card.png" 
                alt="The Academy" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <a 
                href="/training"
                className="inline-block font-headline text-sm tracking-widest border border-tactical-amber text-tactical-amber px-6 py-3 hover:bg-tactical-amber hover:text-black transition"
              >
                BEGIN TRAINING
              </a>
            </div>
          </div>

          {/* Data Hub Card */}
          <div className="border border-tactical-border bg-tactical-dark rounded overflow-hidden">
            <div className="p-6">
              <h3 className="font-headline text-2xl tracking-wider text-white mb-2">DATA HUB</h3>
              <p className="font-body text-gray-400 mb-4">Missions. Writing. Intelligence.</p>
            </div>
            <div className="h-48 overflow-hidden">
              <img 
                src="/images/datahub-card.png" 
                alt="Data Hub" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <a 
                href="https://play.counterscripthq.com/data-hub"
                className="inline-block font-headline text-sm tracking-widest border border-tactical-amber text-tactical-amber px-6 py-3 hover:bg-tactical-amber hover:text-black transition"
              >
                LAUNCH TERMINAL
              </a>
            </div>
          </div>

          {/* Gear Card */}
          <div className="border border-tactical-border bg-tactical-dark rounded overflow-hidden">
            <div className="p-6">
              <h3 className="font-headline text-2xl tracking-wider text-white mb-2">GEAR</h3>
              <p className="font-body text-gray-400 mb-4">Apparel. Supplies. Gear.</p>
            </div>
            <div className="h-48 overflow-hidden">
              <img 
                src="/images/gear-card.png" 
                alt="Gear" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <a 
                href="/gear"
                className="inline-block font-headline text-sm tracking-widest border border-tactical-amber text-tactical-amber px-6 py-3 hover:bg-tactical-amber hover:text-black transition"
              >
                ACCESS ARMORY
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* Section Divider - Mission */}
      <div className="section-divider">
        <span>MISSION</span>
      </div>

      {/* Mission Section */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="tactical-card tactical-card-glow">
            <h2 className="font-headline text-3xl tracking-wider text-center mb-8 text-tactical-amber">MISSION</h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                More than 60% of students in the United States read below grade level. This doesn't just result in low test scores — it affects communication, emotional intelligence, and a student's ability to stand up for themselves. When literacy skills are weak, it becomes harder to question information, explain ideas clearly, or push back when something is wrong. Silence and erasure thrive in those gaps. This is why illiteracy is an epidemic worth confronting.
              </p>
              <p>
                CounterScript HQ exists to fight that. This is a training headquarters for resistance literacy — a place where students learn to resist silence and erasure by fighting for literacy by any means necessary. CounterScript HQ houses COUP: The CounterScript, a tactical, writing-based game where students train under pressure, learning how ideas are built, challenged, defended, and strengthened through writing.
              </p>
              <p>
                Through the Training program, students learn the foundations of strong writing: how to craft hooks and theses, develop and evaluate evidence, identify research gaps and vulnerabilities, and strengthen their own work through revision. This preparation goes far beyond the game, carrying into research papers, literary and peer reviews, proposals, college and scholarship essays, and even dissertations. CounterScript HQ is where writing becomes preparation, clarity, and power — and where students learn to use their voice deliberately and effectively.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider - What is COUP */}
      <div className="section-divider">
        <span>THE GAME</span>
      </div>

      {/* What is COUP Section */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="tactical-card tactical-card-glow tactical-card-cyan">
            <h2 className="font-headline text-3xl tracking-wider text-center mb-8 text-tactical-cyan">WHAT IS COUP: THE COUNTERSCRIPT?</h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                COUP: The CounterScript is a tactical, writing-based game where factions compete to take control of a shared map. Territory isn't claimed through force — it's claimed through writing. In COUP, writing is voice, and voice is power. The faction with the strongest voice controls the map.
              </p>
              <p>
                Each round begins with a timed writing prompt. Factions must produce a hook, thesis, or piece of evidence under pressure. The first faction to complete the breach claims a node on the map. Once territory is taken, the writing is shared and examined by the other factions.
              </p>
              <p>
                From there, the game shifts into analysis and challenge. Teams read closely, gather intel, and identify weaknesses in opposing writing. When a vulnerability is found, a CounterScript can be deployed — structured challenges that force the defending faction to revise, strengthen, or correct their work in real time. Nodes change hands when writing fails to hold up, and control is maintained when it does.
              </p>
              <p>
                Every move in COUP is tied to literacy skills: clarity of claims, strength of evidence, logical structure, and command of language. You don't win by being loud. You win by being precise. The faction that can write clearly, defend their ideas, and respond under pressure is the faction that controls the board.
              </p>
              <p>
                COUP is currently in beta and free to play. As the game continues to evolve, feedback from students and educators helps shape new mechanics, prompts, and training tools. COUP is not finished — it's being built in real time, by the people using it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider - Goals */}
      <div className="section-divider">
        <span>GOALS</span>
      </div>

      {/* Goals Section */}
      <section className="py-12 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            
            <div className="tactical-card tactical-card-glow">
              <h3 className="font-headline text-xl tracking-wider text-tactical-amber mb-4">CROSS-CURRICULAR DEPLOYMENT</h3>
              <p className="text-gray-400">
                COUP is designed for English, social studies, science, and fine arts. Writing becomes tactical — and essential — in every subject.
              </p>
            </div>
            
            <div className="tactical-card tactical-card-glow">
              <h3 className="font-headline text-xl tracking-wider text-tactical-amber mb-4">CLASS VS CLASS ENGAGEMENT</h3>
              <p className="text-gray-400">
                Inter-class and inter-school competitions where writing skill determines victory.
              </p>
            </div>
            
            <div className="tactical-card tactical-card-glow">
              <h3 className="font-headline text-xl tracking-wider text-tactical-amber mb-4">NATIONAL EXPANSION</h3>
              <p className="text-gray-400">
                Coming soon: regional and national competitions where the strongest writers compete at the highest level.
              </p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-20 px-4 bg-tactical-dark">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-headline text-4xl md:text-5xl tracking-wider text-white leading-tight">
            WRITING IS NOT NEUTRAL.<br />
            <span className="text-tactical-amber">VOICE IS POWER.</span>
          </h2>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 bg-tactical-black border-t border-tactical-border">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-8">
              <a href="/" className="font-headline text-sm tracking-widest text-gray-400 hover:text-white transition">HOME</a>
              <a href="/training" className="font-headline text-sm tracking-widest text-gray-400 hover:text-white transition">TRAINING</a>
              <a href="https://play.counterscripthq.com/data-hub" className="font-headline text-sm tracking-widest text-gray-400 hover:text-white transition">DATA HUB</a>
              <a href="/gear" className="font-headline text-sm tracking-widest text-gray-400 hover:text-white transition">GEAR</a>
              <a href="/contact" className="font-headline text-sm tracking-widest text-gray-400 hover:text-white transition">CONTACT</a>
            </div>
            <p className="font-mono text-xs text-gray-500">Beta Infrastructure. Systems may change.</p>
          </div>
        </div>
      </footer>

    </div>
  );
}
